import React from 'react';
import { Box } from '@mui/material';
import TeamPasswordResetHeader from 'team/components/adminPasswordReset/TeamPasswordResetHeader';
import TeamPasswordResetList from 'team/components/adminPasswordReset/TeamPasswordResetList';

const TeamAdminPasswordResetContainer = () => {
    return (
        <Box>
            <TeamPasswordResetHeader />
            <TeamPasswordResetList />
        </Box>
    );
};

export default TeamAdminPasswordResetContainer;
